import { SUCCESSFULLY_LOGIN, LOGOUT } from "./actionTypes";

export function successfullyLogin(payload) {
  return {
    type: SUCCESSFULLY_LOGIN,
    payload: payload
  };
}

export function logout() {
  return {
    type: LOGOUT
  };
}
